module.exports = __webpack_public_path__ + "img/logo-dark.50249e64.png";